import { render } from "./CulturaEmpresaComponent.vue?vue&type=template&id=704319a0&scoped=true"
import script from "./CulturaEmpresaComponent.vue?vue&type=script&lang=js"
export * from "./CulturaEmpresaComponent.vue?vue&type=script&lang=js"

import "./CulturaEmpresaComponent.vue?vue&type=style&index=0&id=704319a0&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704319a0"]])

export default __exports__